import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../helpers';

@customElement(tagName('dotted-line'))
export class DottedLineComponent extends TmElement {
  static override styles = [
    css`
      :host {
        --mask: '';
        --height: 1px;
        block-size: var(--height);
        display: block;
        mask-image: var(--mask);
      }
    `,
  ];

  @property({ type: Number })
  height = 2;

  @property({ attribute: 'dot-width', type: Number, reflect: true })
  dotWidth = 2;

  override render() {
    this.style.setProperty('--mask', this.#renderLine());
    this.style.setProperty('--height', `${this.height}px`);

    return nothing;
  }

  #renderLine() {
    const h = this.height;
    const w = Math.max(2, this.dotWidth * 1.5);
    const dw = this.dotWidth;

    return `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='${w}px' height='${h}px'><rect width='${dw}px' height='100%' /></svg>")`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-dotted-line': DottedLineComponent;
  }
}
